export const RESTRICTED_TERRITORIES = [
  "AU", // Australia
  "AW", // Aruba
  "BQ", // Bonaire
  "CW", // Curacao
  "FR", // France
  "NL", // Netherlands
  "BQ", // Saba
  "ES", // Spain
  "BQ", // Statia
  "SX", // St Martin
  "GB", // United Kingdom
  "US", // United States
];

export const GEO_API_PROVIDERS = [
  {
    url: "https://ipapi.co/json/",
    countryCodePath: "country_code",
  },
  {
    url: "http://ip-api.com/json/",
    countryCodePath: "countryCode",
  },
  {
    url: "https://ipgeolocation.abstractapi.com/v1/",
    countryCodePath: "country_code",
    apiKey: process.env.REACT_APP_ABSTRACT_API_KEY,
  },
];

export const RETRY_ATTEMPTS = 3;
export const RETRY_DELAY = 1000; // Base delay in ms

export const RESTRICTION_MESSAGE =
  "As per gaming license norms, we are unable to accept players from your region.";
